{
  "version": 1,
  "asset_id": "0d72c46c-7617-48e7-9f9f-3dd836d2677e",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/0d72c46c-7617-48e7-9f9f-3dd836d2677e/jakub-kocjan.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/0d72c46c-7617-48e7-9f9f-3dd836d2677e/jakub-kocjan.jpg",
  "original_filename": "jakub-kocjan.jpg",
  "size": 36268,
  "content_type": "image/jpeg",
  "created_at": "2026-09-15T11:24:27Z"
}
